import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  base_url: string;

  constructor(private http: HttpClient,
    ) { 
      this.base_url = environment.appUrl + "/branches";
    }

    getAllBranches(): Observable<any> {
      return this.http.get(this.base_url);
    }
  
}
